import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { CallbackComponent as KeycloakCallbackComponent } from './core/components/callback/callback.component';
import { CallbackComponent as JiraCallbackComponent } from './features/auth-callback/callback.component';
import { KeycloakAuthGuard } from './core/guards/keycloak-auth.guard';
import { QuestionComponent } from './features/question/pages/question.component';
import { SupportChatComponent } from './features/support/pages/support-chat/support-chat.component';
import { CreateTicketComponent } from './features/tickets/create-ticket/create-ticket.component';
import { GoodbyeComponent } from './features/goodbye/goodbye.component';

export const routes: Routes = [
  // Default route redirects to /question as it was at the beginning
  { path: '', redirectTo: '/question', pathMatch: 'full' },

  { path: 'callback', component: KeycloakCallbackComponent },
  { path: 'auth-callback', component: JiraCallbackComponent },
  {
    path: 'question',
    component: QuestionComponent,
    canActivate: [KeycloakAuthGuard]
  },
  {
    path: 'support',
    component: SupportChatComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'tickets/create',
    component: CreateTicketComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'logout',
    component: GoodbyeComponent
  },
];
